/**
 * Copyright (c) Microsoft Corporation
 * All rights reserved. See License.txt in the project root for license information.
 * IGeneraProductDetails contentModule Interface Properties
 * THIS FILE IS AUTO-GENERATED - MANUAL MODIFICATIONS WILL BE LOST
 */

import * as Msdyn365 from '@msdyn365-commerce/core';

export const enum displayStyle {
    accordion = 'accordion',
    table = 'table'
}

export const enum collectionType {
    fitment = 'fitment',
    interchange = 'interchange'
}

export interface IGeneraProductDetailsConfig extends Msdyn365.IModuleConfig {
    heading?: IHeadingData;
    displayStyle?: displayStyle;
    collectionType: collectionType;
    className?: string;
    clientRender?: boolean;
}

export interface IGeneraProductDetailsResources {
    trueValueText: string;
    falseValueText: string;
}

export const enum HeadingTag {
    h1 = 'h1',
    h2 = 'h2',
    h3 = 'h3',
    h4 = 'h4',
    h5 = 'h5',
    h6 = 'h6'
}

export interface IHeadingData {
    text: string;
    tag?: HeadingTag;
}

export interface IGeneraProductDetailsProps<T> extends Msdyn365.IModule<T> {
    resources: IGeneraProductDetailsResources;
    config: IGeneraProductDetailsConfig;
}
